import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Box, Skeleton } from '@mui/material'

import { useEffect } from 'react';
import { useState } from 'react';


import { SetToPlay } from "../../../redux/v2/favorite/actions";
import { SetSelectedProgram } from "../../../redux/v2/program/actions";
import { SetSelectedWorkout, GetPendingWorkout } from "../../../redux/v2/workout/actions";
import { UpdateFavorite } from '../../../redux/v2/user/actions';
import { delay } from '../../../utils';

import { programLevels } from '../../../constants';
import ProgressBar from '../../ProgressBar';

import "./style.css"
import moment from 'moment';
import { Heart } from '../../CustomIcons';
import { GrUndo } from 'react-icons/gr';


const Card = (props) => {
    const navigate = useNavigate();
    const [skeleton, setSkeleton] = useState(true)
    const [cover, setCover] = useState(false)
    const [timer, setTimer] = useState(null);

    const { video, isFavorite, withDate, isViewdWorkout } = props;
    const { programs, program } = props.Program;

    useEffect(() => {
        setTimeout(() => setSkeleton(false), 500)
    }, [])

    const wProgram = programs.filter(p => p.id == video.program_id)[0];
    let levelW = programLevels[video.program_detail_id];
    let duration = Math.round(video?.video_time / 60);

    const gradient = wProgram?.gradient ? wProgram?.gradient?.split("-") : null;

    return (
        <Box className='t-card' display='flex' sx={{ p: 1, border: isViewdWorkout ? ("3px solid " + gradient[0]) : "" }} onClick={async (e) => {
            if (e.target.nodeName != "path" && e.target.nodeName != "svg") {
                props.SetSelectedWorkout(video);
                props.SetSelectedProgram(wProgram);

                navigate(`/workout?workout=${video.id}`);
            }
        }}>
            <Box className='main-wrapper' style={{ marginRight: "5px" }}>
                <div className='img-wrapper'>
                    {(skeleton) ? (
                        <Skeleton className='skeleton-img' variant="rectange" />
                    ) : (
                        <>
                            <div className='img-holder'>
                                <div className='img-holder-desc'>
                                </div>
                                <img src={video.image + "_295x166"} />
                                {
                                    (video.progress || video.watchedtime) && <ProgressBar min={0} max={video.video_time} value={video.progress || video.watchedtime} showLabel={false} gradient={gradient} />
                                }
                            </div>

                        </>
                    )}

                </div>

            </Box>
            <Box className='card-description'>
                <div className='card-description-wrapper'>
                    <h5>WORKOUT {(video?.workout_number + "").padStart(2, "0")}</h5>
                    <body>{duration} MIN</body>
                    <body>{(wProgram ? wProgram?.title?.toUpperCase() : "") + (levelW ? (" - " + levelW) : "")}</body>
                    {
                        withDate && <h6>{moment(video?.created_at)?.format("L")}</h6>
                    }
                </div>

                {
                    isFavorite && <div className='heart-icon'><Heart onClick={async () => {
                        setTimer(delay(
                            async () => {
                                setCover(false);
                                const res = await props.UpdateFavorite(video, false);
                            }, 4000
                        ));
                        setCover(true);
                    }} /></div>
                }
            </Box>
            {
                isFavorite && <div className='card-cover' style={cover ? { left: "0%" } : {}}>
                    <p>You have removed this from your favorites.</p>
                    <GrUndo onClick={() => {
                        clearTimeout(timer);
                        setTimer(null);
                        setCover(false);
                    }} />
                </div>
            }

        </Box >
    );
};

const mapStateToProps = (state) => ({
    Program: state.Program
});

export default connect(mapStateToProps, {
    SetToPlay,
    SetSelectedProgram,
    SetSelectedWorkout,
    GetPendingWorkout,
    UpdateFavorite,
})(Card);